const prod = {
  API_ENDPOINT_URL: "https://api.gocsapp.com/api/",
  API_HOST: "https://api.gocsapp.com/api/",
};

const qa = {
  API_ENDPOINT_URL: "https://test-api.gocsapp.com/api/",
  API_HOST: "https://test-api.gocsapp.com/api/",
};

const dev = {
  API_ENDPOINT_URL: "http://localhost:3100/api/", //process.env.REACT_APP_API_URL_DEV,
  API_HOST: "http://localhost:3100/", //process.env.REACT_APP_API_HOST_DEV,
};

const getEnv = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "development":
      return qa;
    case "production":
      return prod;
    case "local":
      return dev;
    default:
      break;
  }
};

export const env = getEnv();
